import styled from 'styled-components'

const HeadingNumber = styled.span`
	color: ${props => props.theme.textLight};
	font-family: ${props => props.theme.fontMonospace};
	font-size: 0.8rem;
	font-weight: normal;
`

export default HeadingNumber
